import React from 'react';
import ArrayInput from '../../BQRoutineManagement/components/ArrayInput';
import { Controller, useFormContext } from 'react-hook-form';
import StringInput from '../../BQRoutineManagement/components/StringInput';

type Props = {
  fieldPath: string,
};

export default function PostExclusionCriteriaInput(props: Props) {
  const form = useFormContext();
  return (
    <div className="space-y-2">
      <div className="flex space-x-2 w-full">
        <Controller
          control={form.control}
          name={`${props.fieldPath}.domains`}
          render={({ field: { onBlur, onChange, value } }) => {
            return (
              <div className="w-full space-y-1">
                <p className="input-name" style={{ marginBottom: 0 }}>
                  Domains
                </p>
                <ArrayInput
                  selectOptions={[]}
                  type="string"
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              </div>
            );
          }}
        />
        <Controller
          control={form.control}
          name={`${props.fieldPath}.providers`}
          render={({ field: { onBlur, onChange, value } }) => {
            return (
              <div className="w-full space-y-1">
                <p className="input-name" style={{ marginBottom: 0 }}>
                  Providers
                </p>
                <ArrayInput
                  selectOptions={['gSuite', 'gmail', 'outlook', 'yahoo']}
                  type="string"
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              </div>
            );
          }}
        />
      </div>
      <div className="flex space-x-2 w-full">
        <Controller
          control={form.control}
          name={`${props.fieldPath}.ranks`}
          render={({ field: { onBlur, onChange, value } }) => {
            return (
              <div className="w-full space-y-1">
                <p className="input-name" style={{ marginBottom: 0 }}>
                  Ranks
                </p>
                <ArrayInput
                  selectOptions={[1, 2, 3, 4, 5, 6, 7, 8]}
                  type="number"
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              </div>
            );
          }}
        />
        <Controller
          control={form.control}
          name={`${props.fieldPath}.companyNameRegexp`}
          render={({ field: { onBlur, onChange, value } }) => {
            return (
              <div className="w-full space-y-1">
                <p className="input-name" style={{ marginBottom: 0 }}>
                  Company Name Regexp
                </p>
                <div className="flex w-full space-x-1 items-center">
                  <div>/</div>
                  <StringInput
                    customValidator={str => {
                      try {
                        new RegExp(`/${str}/`);
                        return null;
                      } catch (e) {
                        return 'Invalid regexp';
                      }
                    }}
                    placeholder="Filter for company name, should be a valid regexp"
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                  <div>/</div>
                </div>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}
